import { Link } from "react-router-dom";

const avatarImages = [
  "https://readdy.ai/api/search-image?query=Natural%20portrait%20of%20young%20European%20woman%20with%20warm%20genuine%20smile%2C%20soft%20natural%20daylight%2C%20neutral%20cream%20background%2C%20minimalist%20professional%20headshot%2C%20friendly%20approachable%20look&width=120&height=120&seq=hbs-v2-avatar-01&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Natural%20portrait%20of%20young%20European%20man%20with%20kind%20expression%2C%20soft%20diffused%20daylight%2C%20neutral%20beige%20background%2C%20minimalist%20professional%20headshot%2C%20confident%20friendly%20look&width=120&height=120&seq=hbs-v2-avatar-02&orientation=squarish",
  "https://readdy.ai/api/search-image?query=Natural%20portrait%20of%20European%20woman%20in%20thirties%2C%20warm%20authentic%20smile%2C%20soft%20natural%20window%20light%2C%20cream%20minimalist%20background%2C%20professional%20friendly%20headshot&width=120&height=120&seq=hbs-v2-avatar-03&orientation=squarish",
];

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20artistic%20flatlay%20of%20neutral%20tone%20linen%20clothing%20scattered%20with%20dried%20flowers%20and%20textured%20paper%2C%20gentle%20morning%20light%20from%20left%2C%20European%20minimalist%20editorial%20photography%2C%20cream%20blush%20and%20sage%20palette%2C%20organic%20composition%2C%20no%20text%20no%20logos%2C%20dreamy%20soft%20focus&width=1800&height=1200&seq=hbs-v2-hero-bg-main&orientation=landscape"
          alt="Hipobuy Spreadsheet - Mode et style de vie"
          className="w-full h-full object-cover object-top"
          title="Hipobuy Spreadsheet - Collection mode"
        />
      </div>
      {/* Overlay */}
      <div className="absolute inset-0 z-[1] bg-gradient-to-b from-background-50/90 via-background-50/93 to-background-50/90"></div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-12 pt-24 pb-16 md:pt-32 md:pb-24">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-12 md:gap-16">
          <div className="flex-1 max-w-2xl">
            <div className="flex items-center gap-4 mb-10 md:mb-14">
              <div className="flex -space-x-3">
                {avatarImages.map((src, i) => (
                  <div
                    key={i}
                    className="w-10 h-10 md:w-12 md:h-12 rounded-full border-2 border-background-50 overflow-hidden"
                    style={{ zIndex: 3 - i }}
                  >
                    <img
                      src={src}
                      alt={`Utilisateur Hipobuy Spreadsheet ${i + 1}`}
                      className="w-full h-full object-cover"
                      title="Utilisateur Hipobuy Spreadsheet"
                    />
                  </div>
                ))}
              </div>
              <p className="text-xs md:text-sm text-foreground-700 font-sans whitespace-nowrap">
                <strong className="text-foreground-900">Plus de 10 000 utilisateurs</strong> utilisent déjà Hipobuy Spreadsheet
              </p>
            </div>

            <h1 className="mb-10 md:mb-14">
              <span className="block text-5xl md:text-7xl lg:text-8xl font-bold text-foreground-950 font-heading leading-[1.05]">
                Hipobuy Spreadsheet
              </span>
              <span className="block text-3xl md:text-5xl lg:text-6xl italic font-light text-foreground-700 font-heading mt-3 md:mt-4 leading-[1.15]">
                Le système intelligent de suivi
              </span>
            </h1>

            <div className="flex flex-col sm:flex-row items-start gap-4">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="group inline-flex items-center gap-3 bg-background-50 border border-background-300/60 text-foreground-800 font-sans text-sm md:text-base font-medium px-7 py-3.5 rounded-full hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                hipobuy spreadsheet
                <span className="w-7 h-7 rounded-full bg-foreground-950 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                  <i className="ri-arrow-right-line text-background-50 text-xs"></i>
                </span>
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="group inline-flex items-center gap-3 bg-foreground-950 text-background-50 font-sans text-sm md:text-base font-medium px-7 py-3.5 rounded-full hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                buy it now
                <span className="w-7 h-7 rounded-full bg-background-50 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                  <i className="ri-arrow-right-line text-foreground-950 text-xs"></i>
                </span>
              </a>
            </div>

            <div className="mt-10 flex flex-wrap gap-3">
              <Link
                to="/article/guide-complet"
                className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-primary-500 transition-colors font-sans group"
              >
                <i className="ri-article-line"></i>
                <span>Guide complet 2026</span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </Link>
              <Link
                to="/article/guide-shopping"
                className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-primary-500 transition-colors font-sans group ml-4"
              >
                <i className="ri-shopping-bag-line"></i>
                <span>Guide Shopping</span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </Link>
            </div>
          </div>

          <div className="lg:max-w-sm lg:pb-6">
            <p className="text-sm md:text-base text-foreground-600 font-sans leading-relaxed">
              Optimisez vos dépenses, suivez chaque achat et prenez le contrôle total de vos finances avec le <strong className="text-foreground-800">Hipobuy Spreadsheet</strong>. Une solution intelligente, personnalisable et sans abonnement pour gérer votre budget personnel au quotidien.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}